import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { IInfoCard } from '@/interfaces/common'
import { RichText } from '@/shared/ui/rich-text'
import style from './text-card.module.scss'

export interface TextCardProps extends Omit<HTMLProps<HTMLDivElement>, 'title'>, IInfoCard {}

export const TextCard = forwardRef<HTMLDivElement, TextCardProps>((props, ref) => {
  const { className, title, description, image } = props

  return (
    <div className={clsx(style.container, className, 'text text_type_h2')} ref={ref}>
      <div className={style.header}>
        <span>{title}</span>
        {image && (
          <div className={style.logo}>
            <Image src={image.url} alt={image.title} fill />
          </div>
        )}
      </div>
      <RichText className={clsx('text text_type_h2 text_color_dark-070', style.text)} text={description} />
    </div>
  )
})

TextCard.displayName = 'TextCard'
